<template>
  <div>
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('emplacement.typeEmplacementCreation') }}
                </h1>
                <app-breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button"
                      @click="$router.go(-1)">
                {{ $t('general.button.cancel')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="columns">
      <div class="card column is-2 is-cursor-pointer"
           @click="checkPermissions(emplacementPerm.maj)
           ? afficheFenetre('m.gabed.emplacement-adresse') : showPopUp()">
        <div class="card-content">
          <div class="addresseImageEmplacement mg-auto"></div>
          <p class="is-size-4 has-text-weight-bold has-text-centered">
            {{ $t('emplacement.adresse')}}
          </p>
        </div>
      </div>
      <div class="card column is-2 is-cursor-pointer mgl-30px"
           @click="checkPermissions(emplacementPerm.maj)
           ? afficheFenetre('m.gabed.emplacement-centreCommercial') : showPopUp()">
        <div class="card-content">
          <div class="centreCommercialImageEmplacement mg-auto"></div>
          <p class="is-size-4 has-text-weight-bold has-text-centered">
            {{ $t('emplacement.centreCommercial')}}
          </p>
        </div>
      </div>
      <div class="card column is-2 is-cursor-pointer mgl-30px"
           @click="checkPermissions(emplacementPerm.maj)
           ? afficheFenetre('m.gabed.emplacement-ligneBus') : showPopUp()">
        <div class="card-content">
          <div class="ligneBusImageEmplacement mg-auto"></div>
          <p class="is-size-4 has-text-weight-bold has-text-centered">
            {{ $t('emplacement.ligneBus')}}
          </p>
        </div>
      </div>
      <div class="card column is-2 is-cursor-pointer mgl-30px"
           @click="checkPermissions(emplacementPerm.maj)
           ? afficheFenetre('m.gabed.emplacement-parking') : showPopUp()">
        <div class="card-content">
          <div class="parkingImageEmplacement mg-auto"></div>
          <p class="is-size-4 has-text-weight-bold has-text-centered">
            {{ $t('emplacement.parking')}}
          </p>
        </div>
      </div>
      <div
        class="card column is-2 is-cursor-pointer mgl-30px"
        v-if="moduleEmplacementClientActive"
        @click="checkPermissions(emplacementPerm.maj)
          ? afficheFenetre('m.gabed.emplacement-client') : showPopUp()">
        <div class="card-content">
          <div class="clientImageEmplacement mg-auto"></div>
          <p class="is-size-4 has-text-weight-bold has-text-centered">
            {{ $t('emplacement.client')}}
          </p>
        </div>
      </div>
    </div>
    <br>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="900">
      <router-view class="componentStructure"></router-view>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'm_ajoutEmplacement',
  data() {
    return {
      showAdresse: false,
      emplacementPerm: EMPLACEMENT,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    afficheFenetre(nameRoute) {
      this.$router.replace({ name: nameRoute });
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeClients.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('emplacement.emplacement'), route: { name: 'l.gabed.emplacement' }, isActive: false },
        { title: this.$i18n.t('emplacement.typeEmplacement'), route: '', isActive: true },
      ];
      return output;
    },
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
    this.setInformationPage(this.$t('pagePatrimoine.emplacement.creation'));
  },
};
</script>

<style scoped>

</style>
